// extracted by mini-css-extract-plugin
module.exports = {"tab":"style__tab__odXL3","icon":"style__icon__c1z3w"};